import {createSelector} from 'reselect';
import getPrivacyGroupsFromMetadata from './getPrivacyGroupFromMetadata';

export default createSelector(
  [getPrivacyGroupsFromMetadata],
  privacyGroup => privacyGroup?.includes('TARGETING'),
);
